import type1Img from '../../assets/images/result/enneagram/type1.jpg';
import type2Img from '../../assets/images/result/enneagram/type2.jpg';
import type3Img from '../../assets/images/result/enneagram/type3.jpg';
import type4Img from '../../assets/images/result/enneagram/type4.jpg';
import type5Img from '../../assets/images/result/enneagram/type5.jpg';
import type6Img from '../../assets/images/result/enneagram/type6.jpg';
import type7Img from '../../assets/images/result/enneagram/type7.jpg';
import type8Img from '../../assets/images/result/enneagram/type8.jpg';
import type9Img from '../../assets/images/result/enneagram/type9.jpg';

export const enneagramDescriptions = {
  1: {
    title: "1유형",
    subtitle: "개혁가, 완벽주의자",
    image: type1Img,
    description: "1번 유형은 이상주의적이고 원칙을 중시합니다. 스스로와 타인에게 높은 기준을 요구하며, 정리 정돈과 체계를 중요하게 생각합니다. 옳고 그름에 민감하며, 세상을 더 나은 곳으로 만들고자 노력합니다. 그러나 완벽주의가 지나치면 스스로를 지나치게 비판하거나 타인을 평가하게 될 수 있습니다.",
    states: {
      healthy: "건강한 상태의 1유형은 현실적이고 균형 잡힌 판단을 하며, 자신과 타인의 불완전함을 수용할 수 있습니다. 긍정적이고 이상적인 변화를 추구하면서도 유연성을 잃지 않습니다.",
      average: "평균적인 상태의 1유형은 질서와 체계를 중시하며 세부사항에 집중하는 경향이 있습니다. 자기 검열이 심하고 실수를 용납하지 않으려 합니다.",
      unhealthy: "불건강한 상태의 1유형은 강박적인 완벽주의에 빠지며, 매우 비판적이고 판단적이 됩니다. 융통성이 크게 부족해지고 자신과 타인을 과도하게 통제하려 합니다."
    },
    strengths: [
      "강한 윤리의식",
      "체계적인 문제해결 능력",
      "성실하고 책임감이 강함",
      "높은 자기관리 능력"
    ],
    weaknesses: [
      "지나친 자기비판",
      "경직된 사고방식",
      "과도한 통제욕구",
      "실수에 대한 두려움"
    ]
  },
  2: {
    title: "2유형",
    subtitle: "조력가, 돌봄제공자",
    image: type2Img,
    description: "2번 유형은 타인을 돕고자 하는 욕구가 강하며, 사람들로부터 사랑과 인정을 받고 싶어 합니다. 공감 능력이 뛰어나고 관계를 중요시하지만, 도움을 주는 과정에서 자신의 필요를 간과하거나 타인에게 의존할 수 있습니다. 친절하고 희생적인 모습이 돋보이지만, 지나친 인정 욕구로 힘들어질 수 있습니다.",
    states: {
      healthy: "건강한 상태의 2유형은 진정한 이타심을 바탕으로 타인을 돕되, 건강한 자기애도 함께 가지고 있습니다. 타인과 균형 잡힌 관계를 맺으며 자신의 욕구도 잘 돌볼 줄 압니다.",
      average: "평균적인 상태의 2유형은 타인의 인정과 감사를 받고 싶어하며, 때로는 과도하게 타인의 삶에 관여합니다. 자신의 진정한 필요는 무시한 채 타인의 요구에 집중하는 경향이 있습니다.",
      unhealthy: "불건강한 상태의 2유형은 타인을 감정적으로 조종하려 하며, 과도한 희생으로 인해 심각한 소진을 경험합니다. 타인에 대한 감정적 의존성이 매우 높아지고 거절에 대해 극도로 민감해집니다."
    },
    strengths: [
      "뛰어난 공감능력",
      "따뜻한 배려심",
      "강한 직관력",
      "풍부한 감정표현"
    ],
    weaknesses: [
      "자기희생적 성향",
      "거절하기 어려움",
      "과도한 감정이입",
      "독립성 부족"
    ]
  },
  3: {
    title: "3유형",
    subtitle: "성취가, 실행가",
    image: type3Img,
    description: "3번 유형은 성공과 목표 달성에 강한 동기를 가진 유형입니다. 매우 실용적이고 자신감 있으며, 성과를 통해 가치를 입증하려고 노력합니다. 외형적으로 성공한 모습을 보이는 데 집중하지만, 진정한 내면의 욕구를 무시하거나 지나치게 경쟁적으로 변할 수 있습니다.",
    states: {
      healthy: "건강한 상태의 3유형은 진정한 자아를 인식하고 표현하며, 성취 이외의 가치도 중요하게 여깁니다. 타인의 성장을 돕고 진정성 있는 관계를 맺습니다.",
      average: "평균적인 상태의 3유형은 성공과 인정받기 위해 끊임없이 노력하며, 자신의 이미지를 관리하는 데 많은 에너지를 씁니다. 때로는 진정한 감정을 숨기고 역할에 맞춰 행동합니다.",
      unhealthy: "불건강한 상태의 3유형은 성공에 대한 강박관념에 사로잡히며, 자신의 진정한 모습을 완전히 잃어버립니다. 실패에 대한 두려움이 극도로 커지고 기만적인 행동을 보일 수 있습니다."
    },
    strengths: [
      "뛰어난 실행력",
      "높은 적응력",
      "목표 지향적",
      "효율적인 업무처리"
    ],
    weaknesses: [
      "과도한 경쟁의식",
      "진정성 부족",
      "워커홀릭 성향",
      "실패에 대한 두려움"
    ]
  },
  4: {
    title: "4유형",
    subtitle: "예술가, 개인주의자",
    image: type4Img,
    description: "4번 유형은 감정적으로 풍부하고 창의적이며 독특함을 추구합니다. 자신의 정체성과 깊은 감정에 집중하며, 세상에 특별한 기여를 하고자 합니다. 그러나 때로는 외로움을 느끼거나, 자신과 타인을 비교하며 부정적인 감정에 빠질 수 있습니다.",
    states: {
      healthy: "건강한 상태의 4유형은 자신의 감정을 창조적으로 승화시키며, 타인과의 차이를 건강하게 인정합니다. 깊이 있는 자기표현과 함께 일상의 기쁨도 누릴 줄 압니다.",
      average: "평균적인 상태의 4유형은 자신의 독특함을 강조하며, 때로는 과도한 감정적 기복을 경험합니다. 현실보다는 이상적인 것을 추구하는 경향이 있습니다.",
      unhealthy: "불건강한 상태의 4유형은 극심한 우울감과 소외감에 빠지며, 자기파괴적 행동을 보일 수 있습니다. 타인과의 비교에서 오는 열등감이 매우 강해집니다."
    },
    strengths: [
      "창의적 표현능력",
      "깊은 통찰력",
      "진정성 있는 태도",
      "예술적 감각"
    ],
    weaknesses: [
      "감정기복",
      "현실감각 부족",
      "과도한 자의식",
      "우울 성향"
    ]
  },
  5: {
    title: "5유형",
    subtitle: "관찰자, 사색가",
    image: type5Img,
    description: "5번 유형은 지식과 정보를 갈망하며, 독립적이고 분석적인 사고를 중시합니다. 자신의 에너지와 자원을 절약하며, 세상을 이해하려는 욕구가 강합니다. 하지만 지나치게 고립되거나 감정을 억제하며 인간관계를 멀리할 위험도 있습니다.",
    states: {
      healthy: "건강한 상태의 5유형은 지식을 실제 삶에 적용하며, 타인과 지적 교류를 나누는 것을 즐깁니다. 감정표현도 자연스럽게 하며 세상에 적극적으로 참여합니다.",
      average: "평균적인 상태의 5유형은 관찰자적 입장을 고수하며, 감정적 관여를 최소화하려 합니다. 지식 축적에 몰두하지만 실제 활용은 제한적일 수 있습니다.",
      unhealthy: "불건강한 상태의 5유형은 극도로 고립되며, 현실과의 단절을 경험합니다. 강박적인 사고에 빠지고 사회적 관계를 완전히 차단할 수 있습니다."
    },
    strengths: [
      "뛰어난 분석력",
      "객관적 통찰력",
      "지적 호기심",
      "독립적 사고"
    ],
    weaknesses: [
      "감정표현 부족",
      "사회적 고립",
      "현실참여 회피",
      "과도한 절약성향"
    ]
  },
  6: {
    title: "6유형",
    subtitle: "충성가, 회의론자",
    image: type6Img,
    description: "6번 유형은 신뢰와 안정성을 중요하게 생각하며, 잠재적인 위험을 미리 대비하려는 경향이 있습니다. 협력적이고 책임감이 강하지만, 불안감이 높아 의심이나 걱정을 과도하게 할 수 있습니다. 의존적이거나 권위에 대한 태도가 양극화되기도 합니다.",
    states: {
      healthy: "건강한 상태의 6유형은 내면의 불안을 극복하고 자신과 타인을 신뢰합니다. 용기 있게 도전하며 진정한 안정감을 찾습니다.",
      average: "평균적인 상태의 6유형은 안전을 추구하며 의심이 많아집니다. 권위에 대해 양가적인 태도를 보이며 결정을 내리는 것을 어려워합니다.",
      unhealthy: "불건강한 상태의 6유형은 극도의 불안과 피해망상에 시달립니다. 과도한 의심으로 인해 어떤 결정도 내리지 못하고 공격적이거나 도피적인 행동을 보입니다."
    },
    strengths: [
      "강한 책임감",
      "뛰어난 문제예측",
      "충실한 동료의식",
      "상황판단력"
    ],
    weaknesses: [
      "과도한 불안",
      "우유부단함",
      "의심이 많음",
      "결정장애"
    ]
  },
  7: {
    title: "7유형",
    subtitle: "낙천가, 모험가",
    image: type7Img,
    description: "7번 유형은 긍정적이고 활기차며 다양한 경험을 추구합니다. 자유를 갈망하고 새로운 기회를 탐색하며, 즐거움과 만족을 통해 삶을 채우고자 합니다. 그러나 고통이나 부정적인 감정을 회피하려는 경향이 있어, 깊은 문제를 직면하지 않을 수 있습니다.",
    states: {
      healthy: "건강한 상태의 7유형은 깊이 있는 만족감을 느끼며, 현재에 충실합니다. 자신의 재능을 생산적으로 활용하고 타인의 행복에도 기여합니다.",
      average: "평균적인 상태의 7유형은 끊임없이 새로운 자극을 추구하며, 불편한 감정을 회피하려 합니다. 여러 가지 일을 동시에 벌이지만 마무리는 부족할 수 있습니다.",
      unhealthy: "불건강한 상태의 7유형은 충동적이고 산만해지며, 현실도피적 성향이 강해집니다. 고통스러운 감정을 완전히 부정하고 자기파괴적인 쾌락추구에 빠질 수 있습니다."
    },
    strengths: [
      "긍정적 사고",
      "빠른 적응력",
      "다재다능함",
      "높은 창의성"
    ],
    weaknesses: [
      "집중력 부족",
      "책임감 회피",
      "깊이 있는 관계 형성 어려움",
      "충동적 성향"
    ]
  },
  8: {
    title: "8유형",
    subtitle: "지도자, 도전가",
    image: type8Img,
    description: "8번 유형은 강력한 리더십과 자기 주장이 특징이며, 통제와 권위를 중요시합니다. 자신과 주변 사람들을 보호하려는 욕구가 강하며, 정의감과 결단력이 뛰어납니다. 그러나 지나치게 강압적이거나 분노를 표출하며 갈등을 일으킬 가능성이 있습니다.",
    states: {
      healthy: "건강한 상태의 8유형은 자신의 힘을 타인을 위해 사용하며, 진정한 리더십을 발휘합니다. 자신의 영향력을 긍정적으로 활용하고 취약성도 수용합니다.",
      average: "평균적인 상태의 8유형은 통제력을 유지하려 하며, 때로는 과도하게 강압적일 수 있습니다. 약점을 보이지 않으려 하고 타인의 영역을 침범할 수 있습니다.",
      unhealthy: "불건강한 상태의 8유형은 극도로 지배적이고 공격적이 됩니다. 폭력적인 성향을 보이며 타인의 권리를 무시하고 복수심에 사로잡힐 수 있습니다."
    },
    strengths: [
      "강한 리더십",
      "결단력",
      "정의감",
      "추진력"
    ],
    weaknesses: [
      "과도한 지배욕",
      "공격적 성향",
      "감정표현 부족",
      "타인의 감정 무시"
    ]
  },
  9: {
    title: "9유형",
    subtitle: "중재자, 평화주의자",
    image: type9Img,
    description: "9번 유형은 갈등을 피하고 조화를 유지하려는 성향이 강합니다. 차분하고 타인의 의견을 잘 받아들이며, 균형 잡힌 시각을 유지하려고 노력합니다. 하지만 자기주장을 포기하거나 타인의 기대에 지나치게 순응하여 자신의 욕구를 억누르는 경우가 많습니다.",
    states: {
      healthy: "건강한 상태의 9유형은 내면의 평화를 찾고 적극적으로 자신을 표현합니다. 건강한 중재력을 발휘하며 자신의 목표도 성취해 나갑니다.",
      average: "평균적인 상태의 9유형은 갈등을 피하고 타협하려 합니다. 자신의 의견을 명확히 표현하지 않으며 중요한 결정을 미루는 경향이 있습니다.",
      unhealthy: "불건강한 상태의 9유형은 완전히 수동적이 되며, 현실도피적 성향이 강해집니다. 자신의 존재감을 완전히 지우고 중독적 행동에 빠질 수 있습니다."
    },
    strengths: [
      "뛰어난 중재능력",
      "포용력",
      "경청능력",
      "안정감 있는 성격"
    ],
    weaknesses: [
      "우유부단함",
      "수동적 성향",
      "자기주장 부족",
      "현실회피 성향"
    ]
  }
}; 